import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';

import * as Styled from './no-results.style';

export const NoResults: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Styled.Container>
      <Typography variant="subtitle1">
        {t('general.labels.search.no-results')}
      </Typography>
    </Styled.Container>
  );
};
